import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Twilio from 'twilio-chat';
import { Button, Modal } from 'react-responsive-ui'
import ConversationsList from './conversationsList';
import Chat from './chat';
import { doGetTWilioToken } from '../helpers/registrationHelper';

function removeChannel(channels, toRemove) {
    var index = channels.indexOf(toRemove);
    if (index > -1) {
        channels.splice(index, 1);
    }
    return channels;
}

function addChannel(channels, toAdd) {
    var toReturn = channels.slice();
    if(toReturn.length > 0) {
        toReturn.unshift(toAdd);
        return toReturn
    } else {
        return [toAdd]
    }
}

class Messenger extends Component {
    constructor(props) {
        super(props);
        this.props = props
        this.channelName = 'default-channel';
        this.clientInitiated = this.clientInitiated.bind(this)
        this.channelSelected = this.channelSelected.bind(this)
        // this.createChannel = this.createChannel.bind(this)
        this.deleteChannel = this.deleteChannel.bind(this)
        this.getChannels = this.getChannels.bind(this)
    }

    componentDidMount() {
        doGetTWilioToken(localStorage.getItem('user_id'))
            .then((response) => {
                localStorage.setItem('token_chat', response.data.token)
            });
        let token = localStorage.getItem('token_chat')
        this.chatClient = new Twilio(token);
        this.chatClient.initialize().then(this.clientInitiated.bind(this));
    }

    getChannels() {

        this.chatClient.getSubscribedChannels().then(function (paginator) {
            let unSortedChannels = paginator.items;
            this.setState(prevState => ({ channels: prevState && prevState.channels ? prevState.channels.sort(this.sortFunction).reverse() : unSortedChannels.sort(this.sortFunction).reverse() }))
        }.bind(this));

    }

    sortFunction(a,b){  
        var dateA;// = new Date(a.date).getTime();
        var dateB;// = new Date(b.date).getTime();

        if (a.lastMessage && b.lastMessage) {
            dateA = new Date(a.lastMessage.timestamp).getTime(); 
            dateB = new Date(b.lastMessage.timestamp).getTime();
        } else if (!a.lastMessage && b.lastMessage) {
            dateA = new Date(a.createdAt).getTime(); 
            dateB = new Date(b.lastMessage.timestamp).getTime();
        } else if (!b.lastMessage && a.lastMessage) {
            dateA = new Date(a.lastMessage.timestamp).getTime()
            dateB = new Date(b.createdAt).getTime();
        } else {
            dateA = new Date(a.createdAt).getTime()
            dateB = new Date(b.createdAt).getTime();
        }
        return dateA > dateB ? 1 : -1;  
    }

    sortChannels(channels) {
        let toReturn = channels.sort(function (a, b) {
            if (a.lastMessage && b.lastMessage) {
                return new Date(a.lastMessage.timestamp) - new Date(b.lastMessage.timestamp);
            } else if (!a.lastMessage && b.lastMessage) {
                return new Date(a.createdAt) - new Date(b.lastMessage.timestamp);
            } else if (!b.lastMessage && a.lastMessage) {
                return new Date(a.lastMessage.timestamp) - new Date(b.createdAt);
            } else {
                return new Date(a.createdAt) - new Date(b.createdAt);
            }
        });
        return toReturn;
    }

    clientInitiated() {
        this.getChannels()
        this.chatClient.on('channelJoined', function (channel) {
            if(this.state){
                this.setState( prevState => ({channels: prevState && prevState.channels ? addChannel(prevState.channels, channel) : addChannel([],channel)}))
            }
        }.bind(this));
        this.chatClient.on('channelRemoved', function (channel) {
            console.log('Channel removed: ' + channel.friendlyName);
            this.setState( prevState => ({channels: removeChannel(prevState.channels, channel)}))
        }.bind(this));
        this.chatClient.on('channelInvited', function (channel) {
            channel.join();
            this.getChannels()
            });
    }

    render() {
        if (!this.state) {
            return <div></div>
        } else {
            return (
                <div className="messenger">
                    <Button action={() => this.setState({ showMessenger: true })}>
                        <img className="like-image" alt="Like" src={require("../images/letter.svg")}/>
                    </Button>
                    <Modal className="messenger-modal-wrapper"
                        isOpen={this.state.showMessenger}
                        close={() => this.setState({ showMessenger: false })}>
                        <div className="messenger-modal">
                            {this.state.channel !== undefined && this.state.channel !== null &&
                            <button className="close-conversation-button" onClick={() => { this.channelSelected(null) }}>
                                <img alt="Like" src={require("../images/left-arrow.svg")} />
                            </button>}
                            {(this.state.channel !== undefined && this.state.channel !== null && window.innerWidth<768) ? (<span></span>) : (
                                <ConversationsList getChannels={this.getChannels} chatClient={this.chatClient} activeChannel={this.state.channel} deleteChannel={this.deleteChannel} channelSelected={this.channelSelected} channels={this.state.channels} />
                            )}
                            {this.state.channel !== undefined && this.state.channel !== null &&
                            <div className="active-chat">
                                <Chat channel={this.state.channel} getChannels={this.getChannels}/>
                            </div>
                            }
                        </div>
                    </Modal>

                </div>
            )
        }
    }

    channelSelected(channel) {
        this.setState({ channel })
    }


    deleteChannel(channel) {
        channel.delete().then(function (channel) {
            console.log(`channel deleted successfully${channel.friendlyName}`)
            this.setState({ channel: null })
            this.getChannels()
        }.bind(this))
    }
}

Messenger.propTypes = {
    history: PropTypes.object
};
export default Messenger;


// WEBPACK FOOTER //
// ./src/view/messenger.js